// Console warning utility - Shows warning when console is opened
export const initConsoleWarning = () => {
  // Initial warning message
  const showWarning = () => {
    console.clear();
    console.log(
      "%c⚠️ WARNING ⚠️",
      "color: red; font-size: 50px; font-weight: bold; text-align: center;"
    );
    console.log(
      "%cALL YOUR ACTIVITIES HERE ARE BEING RECORDED",
      "color: red; font-size: 20px; font-weight: bold; text-align: center; padding: 20px;"
    );
    console.log(
      "%cAny attempt to modify or interfere with this system is strictly prohibited and may result in legal action.",
      "color: orange; font-size: 14px; font-weight: bold;"
    );
    console.log(
      "%cThis system is monitored for security purposes.",
      "color: orange; font-size: 14px; font-weight: bold;"
    );
  };

  // Show warning immediately
  showWarning();

  // Detect when DevTools is opened
  let devtools = { open: false, orientation: null };
  const threshold = 160;

  setInterval(() => {
    if (
      window.outerHeight - window.innerHeight > threshold ||
      window.outerWidth - window.innerWidth > threshold
    ) {
      if (!devtools.open) {
        devtools.open = true;
        showWarning();
      }
    } else {
      devtools.open = false;
    }
  }, 500);

  // Override console methods to show warning
  const originalLog = console.log;
  const originalError = console.error;
  const originalWarn = console.warn;
  const originalInfo = console.info;

  const wrapConsoleMethod = (originalMethod) => {
    return function (...args) {
      // Show warning periodically
      if (Math.random() < 0.1) {
        // 10% chance to show warning
        showWarning();
      }
      return originalMethod.apply(console, args);
    };
  };

  // Wrap console methods (optional - can be commented out if too aggressive)
  // console.log = wrapConsoleMethod(originalLog);
  // console.error = wrapConsoleMethod(originalError);
  // console.warn = wrapConsoleMethod(originalWarn);
  // console.info = wrapConsoleMethod(originalInfo);

  // Show warning when console methods are called
  const showWarningOnConsoleUse = () => {
    if (Math.random() < 0.05) {
      // 5% chance to show warning
      showWarning();
    }
  };

  // Monitor console usage
  const consoleMethods = ["log", "error", "warn", "info", "debug"];
  consoleMethods.forEach((method) => {
    const original = console[method];
    console[method] = function (...args) {
      showWarningOnConsoleUse();
      return original.apply(console, args);
    };
  });
};

